// extracted by mini-css-extract-plugin
module.exports = {"windDirection":"windDirection_windDirection__Q3jYL","compass":"windDirection_compass__1ph8V","direction":"windDirection_direction__2xdY8"};